import type { CardIssuerType } from '@/generated/graphql';
import type { AddressNormalizationPageType } from '@/types';
// Types exported in this file will be exported from the main store directory

// Likely will need to move several & share if we convert form to TS
export type DefaultInputState<T = string> = {
  displayError: boolean;
  cardType?: CardIssuerType;
  cobrand?: string;
  error: string;
  errorCode: string;
  /** True - Input that has had value changed */
  isDirty: boolean;
  isValid: boolean;
  value: T;
};

export type CrsFields =
  | 'countryCode'
  | 'taxPayerIdType'
  | 'taxPayerIdValue'
  | 'noTaxPayerIdReason';

export type CrsFieldResult = {
  displayError: boolean;
  error: string;
  value: string;
  isBackendError?: boolean;
};

export type CrsFieldResults = {
  countryCode: CrsFieldResult;
  taxPayerIdType: string;
  taxPayerIdValue: CrsFieldResult;
  noTaxPayerIdReason: CrsFieldResult;
};

export type BaseAddressFields =
  | 'city'
  | 'houseNumber'
  | 'line1'
  | 'line2'
  | 'postalCode'
  | 'state'
  | 'streetName';

export type BaseAddressFieldResults = {
  [key in BaseAddressFields]: DefaultInputState;
};

export enum AUTO_COMPLETE_TYPE {
  ANS = 'ANS',
  BROWSER = 'BROWSER',
  GOOGLE = 'GOOGLE',
  MANUAL = 'MANUAL',
  MERCHANT_PREFILLED = 'MERCHANT_PREFILLED',
}

export type AddressValidationPayload<T extends string> = {
  [key in T]: {
    displayError: boolean;
    errorCode: string;
    isValid: boolean;
  };
};

export type AddressValidationMeta = {
  meta: { hasValidationError: boolean };
};

export type IncentiveOfferState = {
  shouldDisplayOffer?: boolean;
  shouldDisplayOfferAccepted?: boolean;
};

export type AddressNormalizationState = {
  page: AddressNormalizationPageType;
  showBackButton: boolean;
  showNextButton: boolean;
  showSubmitButton: boolean;
};
